import React, { Component } from 'react';
import { MostrarLlegendaSvg } from './LlegendaFooterIconsElement';

export class MostrarCapesLlegendaIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isButtonHovered: false
    };
  }

  render = () => {
    return (
      <MostrarLlegendaSvg
        innerWidth={this.props.windowWidth}
        isHover={this.state.isButtonHovered}
        fontSizeEnabled={this.props.isFontSizeEnabled}
        onMouseEnter={() => this.setState({ isButtonHovered: true })}
        onMouseLeave={() => this.setState({ isButtonHovered: false })}>
        <path d="M101.9,3.1h308.3c54.5,0.1,98.7,44.3,98.8,98.8v308.3c-0.1,54.5-44.3,98.7-98.8,98.8H101.9c-54.5,0-98.7-44.2-98.8-98.7V101.9C3.2,47.4,47.4,3.2,101.9,3.1z M258.5,203.3c27.1,0,49.1,22,49.1,49.1s-22,49.1-49.1,49.1s-49.1-22-49.1-49.1S231.4,203.3,258.5,203.3 M258.5,129.7c81.8,0,151.7,50.9,180,122.7c-28.3,71.8-98.2,122.7-180,122.7s-151.7-50.9-180-122.7C106.8,180.6,176.7,129.7,258.5,129.7 M114.2,252.4c27,55,82.8,90,144.3,90s117.3-35,144.3-90c-27-55-82.8-90-144.3-90S141.2,197.4,114.2,252.4z"></path>
      </MostrarLlegendaSvg>
    );
  };
}
